import type React from 'react';

import { tv, type VariantProps } from 'tailwind-variants';

import cn from '../../../utils/cn';

const tableCell = tv({
  base: 'text-sm font-normal text-gray-dark',
  variants: {
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    condensed: {
      true: 'p-1.5',
      false: 'p-2.5',
    },
  },
  defaultVariants: {
    align: 'left',
    condensed: false,
    isEven: false,
  },
});

type TableCellVariants = VariantProps<typeof tableCell> & React.ComponentPropsWithoutRef<'td'>;

export interface TableCellProps extends TableCellVariants {
  className?: string;
  children: React.ReactNode;
  isEven?: boolean;
}

const TableCell = ({ className, align, condensed, isEven, ...props }: TableCellProps) => <td className={cn(tableCell({ align, condensed }), className)} {...props} />;
TableCell.displayName = 'TableCell';

export default TableCell;
